import { REGEX_PATTERN } from "core/const/validator.const";

export const Fields = [
  {
    type: "email",
    name: "email",
    label: "activationCode.placeholder.email",
    validation: {
      required: "Email is required",
      pattern: {
        value: REGEX_PATTERN.email,
        message: "Please enter the valid email",
      },
    },
  },
];
